import React, { useEffect, useState } from 'react'
import ExternalLink from '@toasttab/shared/src/components/molecules/ExternalLink/ExternalLink'
import Header from '@toasttab/shared/src/components/organisms/Header/Header'
import Footer from '@toasttab/shared/src/components/organisms/Footer/Footer'
import { NTExitIntent } from '@toasttab/shared/src/components/Ninetailed/NT_ExitIntent'
import { isExitIntentAllowedAtPath } from '@toasttab/shared/src/utils/exitIntentUtils'
import { initDataCapture } from '@toasttab/shared/src/hooks/useDataCapture'
import { usePageContext } from '../hooks/usePageContext'
import { MainLayoutProps } from './MainLayout.d'
import SEODebugToolbar from '@toasttab/shared/src/components/Debugger/SEODebugToolbar'
import SimpleHeader from '@toasttab/shared/src/components/organisms/Header/SimpleHeader'
import SimpleStaticNav from '@toasttab/shared/src/components/organisms/Header/SimpleStaticNav'

const MainLayout = ({
  children,
  currentLanguage,
  footerContent,
  localizedEntries,
  mainCss,
  packageName,
  siteId,
  siteMetadata,
  useSimpleHeader = false,
  customSimpleNav
}: MainLayoutProps) => {
  const [showMobileStickyCTA, setShowMobileStickyCTA] = useState(true)
  const { globalSettings, region, url } = usePageContext()

  const { exitIntentShowcaseForm, exitIntentJsonDataObjectBaseline } =
    globalSettings ?? {}

  useEffect(() => {
    initDataCapture()
  }, [])

  useEffect(() => {
    // Hard-coding override to disable sticky CTA for new Fall Release 2024 page and local restaurant sales comparison, need a contentmodel change for this probably
    if (
      typeof window !== 'undefined' &&
      (window.location.pathname === '/innovation-hub/fall-2024' ||
        window.location.pathname === '/local-restaurant-sales-comparison' ||
        window.location.pathname === '/request-demo')
    ) {
      setShowMobileStickyCTA(false)
    }
  }, [])

  const renderHeader = () => {
    if (useSimpleHeader) {
      // Use SimpleHeader for better performance on simple pages
      return (
        <SimpleHeader
          localizedEntries={localizedEntries}
          packageName={packageName}
          siteId={siteId}
        >
          {customSimpleNav || (
            <SimpleStaticNav
              localizedEntries={localizedEntries}
              siteId={siteId}
              siteRegion={region.toLowerCase()}
            />
          )}
        </SimpleHeader>
      )
    } else {
      // Use full Header for pages with complex navigation
      return (
        <Header
          enabledMobileStickyCTA={showMobileStickyCTA}
          localizedEntries={localizedEntries}
          siteId={siteId}
          siteMetadata={siteMetadata}
        />
      )
    }
  }
  return (
    <>
      <div>
        {exitIntentShowcaseForm && isExitIntentAllowedAtPath(url) ? (
          <NTExitIntent
            exitIntentJsonDataObjectBaseline={exitIntentJsonDataObjectBaseline}
            exitIntentShowcaseForm={exitIntentShowcaseForm}
          />
        ) : null}
        {renderHeader()}
        <main className={mainCss}>{children}</main>
        <Footer
          currentLanguage={currentLanguage}
          footerContent={footerContent}
          hostName={siteMetadata?.hostName}
          localizedEntries={localizedEntries}
          packageName={packageName}
          siteId={siteId}
          siteMetadata={siteMetadata}
        />
        <ExternalLink />
      </div>
      {/* Add the SEO Debug Toolbar */}
      {(process.env.NODE_ENV === 'development' ||
        process.env.NODE_ENV === 'preview') && <SEODebugToolbar />}
    </>
  )
}

export default MainLayout
